var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIcSupportOn = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 20,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#479DA6",
  fillRule: "evenodd",
  d: "M12.31 1.585c-.21.04-.42.04-.62 0L3.67.065c-.9-.17-1.84.06-2.55.64S0 2.125 0 3.035v12.26c0 1.45 1.05 2.7 2.5 2.97l8.82 1.67c.45.09.92.09 1.37 0l8.82-1.67c1.45-.27 2.5-1.52 2.5-2.97V3.035c0-.9-.41-1.76-1.12-2.34s-1.64-.81-2.55-.64l-8.02 1.52z",
  clipRule: "evenodd"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#E6F0F1",
  d: "M9.101 8.526c-.06 0-.12 0-.19-.02l-4.13-.86a.898.898 0 1 1 .37-1.76l4.13.86a.898.898 0 0 1-.18 1.78M9.04 14.146c-.06 0-.12 0-.19-.02l-4.13-.86c-.49-.1-.8-.58-.7-1.07a.91.91 0 0 1 1.07-.7l4.13.86c.49.1.8.58.7 1.07-.09.42-.46.72-.88.72M14.9 8.524c-.42 0-.79-.29-.88-.72-.1-.49.21-.96.7-1.07l4.13-.86c.49-.1.96.21 1.07.7s-.21.96-.7 1.07l-4.13.86c-.06.01-.12.02-.19.02M14.961 14.145c-.42 0-.79-.29-.88-.72-.1-.49.21-.96.7-1.07l4.13-.86c.49-.1.96.21 1.07.7.1.49-.21.96-.7 1.07l-4.13.86c-.06.01-.12.02-.19.02"
})));
export default SvgIcSupportOn;